import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ff00120"
import script from "./partyDetails.js?vue&type=script&lang=js&external"
export * from "./partyDetails.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports